import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Exchange} from '../models/models';

@Injectable()
export class ExchangeService {

  constructor(private httpClient: HttpClient) {
  }

  getExchanges() {
    return this.httpClient.get<Exchange[]>(environment.baseUrlWs + '/api/exchanges');
  }
}
